import React from 'react';
import './ExpandableItem.less';
import ListItem from '../../components/ListItem/ListItem';

type Props = {
  initiallyOpened?: boolean;
  children?: any;
  showSeparator?: boolean;
  title: any;
  value?: any;
  onClickOver: () => void;
  titleClassName: any;
  containerStyles: any;
  showIncomplete?: boolean;
  hideValueOnExpand?: boolean;
  valueStyles?: any;
  brandValueColor?: boolean;
  hideArrow?: boolean;
  hideIfOpened?: boolean;
  testid?: string;
  customIsOpened?: boolean;
  disabled?: boolean;
};

const ExpandableItem = ({
  initiallyOpened,
  children,
  value,
  title,
  showSeparator,
  onClickOver,
  titleClassName,
  containerStyles,
  showIncomplete,
  hideValueOnExpand,
  valueStyles,
  brandValueColor,
  hideArrow,
  hideIfOpened,
  testid,
  customIsOpened,
  disabled = false,
}: Props) => {
  const [isOpened, setIsOpened] = React.useState(initiallyOpened);

  return (
    <div style={{ width: '100%' }}>
      <ListItem
        testid={testid}
        containerStyles={containerStyles || { padding: '10px 16px', margin: 0 }}
        leftItem={
          <div
            data-testid={`ExpandableItem-${testid}`}
            className={titleClassName || 'expandable-item-title'}
          >
            {title}
          </div>
        }
        value={hideValueOnExpand && isOpened ? null : value}
        valueStyles={valueStyles}
        onClick={() => {
          if (children && customIsOpened === null) {
            setIsOpened(!isOpened);
          } else {
            onClickOver();
          }
        }}
        rightIcon={
          hideArrow
            ? undefined
            : customIsOpened || isOpened
            ? 'arrowUp'
            : 'arrowDown'
        }
        rightIconSize={12}
        showSeparator={false}
        brandValueColor={children && brandValueColor}
        showIncomplete={showIncomplete && !(customIsOpened || isOpened)}
        disabled={disabled}
      />
      {(customIsOpened || isOpened) && children}
      {showSeparator && !((customIsOpened || isOpened) && hideIfOpened) && (
        <div className="expandable-separator" />
      )}
    </div>
  );
};

ExpandableItem.defaultProps = {
  initiallyOpened: false,
  showSeparator: true,
  onClickOver: () => {},
  children: null,
  titleClassName: null,
  containerStyles: null,
  showIncomplete: false,
  value: null,
  valueStyles: null,
  brandValueColor: true,
  hideArrow: false,
  hideIfOpened: false,
  customIsOpened: null,
};

export default React.memo(ExpandableItem);
